<script setup lang="ts">
  defineOptions({
    inheritAttrs: false,
  })

  const { pageSize, modelValue, showSizePicker } = defineProps<{
    modelValue: number
    pageSize?: number
    pageSizes?: Array<number | { label: string; value: number }>
    pageSlot?: number
    showSizePicker?: boolean
    totalPages: number | undefined | null
  }>()

  const emit = defineEmits<{
    (e: 'update:modelValue', page: number): void
    (e: 'update:pageSize', pageSize: number): void
  }>()

  const attrs = useAttrs()

  const page = computed({
    get: () => modelValue,
    set: (value: number) => emit('update:modelValue', value),
  })

  const paginationClass = computed(() => {
    const classes = ['items-center [&_.n-pagination-item--button--disabled_.n-base-icon]:text-disabled!']

    if (showSizePicker) {
      classes.push('w-full [&_.n-select]:order-first [&_.n-select]:mr-auto!')
    }

    return classes
  })
</script>

<template>
  <div
    v-if="totalPages"
    :class="attrs.class"
    data-testid="ui-pagination"
  >
    <NPagination
      v-model:page="page"
      :page-count="totalPages"
      :page-slot="pageSlot ?? undefined"
      :page-size="showSizePicker ? pageSize : undefined"
      :page-sizes="showSizePicker ? pageSizes : undefined"
      :show-size-picker="showSizePicker"
      size="small"
      :class="paginationClass"
      @update:page-size="(value) => emit('update:pageSize', value)"
    />
  </div>
</template>
